import React, { useEffect } from "react";
import { BASE_URL } from "./../../global";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useTheme } from "@mui/material/styles";
import { toast } from "react-toastify";
import { Toolbar, TextField, Autocomplete, Modal, Box, useMediaQuery, Grid, Tooltip, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, ButtonGroup, Button, Paper, IconButton} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ListWrap from "../commonComponent/listWrap";
import { paginationrowsPerPageOptions } from "../../constants/commonConst";
import moment from "moment";
import { calTypeOption, orserTYpeArray, partyArray, orderStatusOption } from "./editindependentSrf";
import { locationOptions } from "../../constants/srfConstants";
import { getFormattedDates } from "../../utils/utils";
import ExcelDownload from "../../utils/components/excelDownload";

const IndependentSrfList = () => {
  const urlPath = useLocation();
  const isMobile = useMediaQuery("(max-width: 600px)");

  const [page, setPage] = React.useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = React.useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Client Name");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [totalRows, setTotalRows] = React.useState(0);
  const [IndependentSrfList, setIndependentSrfList] = React.useState([]);
  const [finalData, setFinalData] = React.useState([]);
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true");
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const [from, setFrom] = React.useState(() => {
    const stored = sessionStorage.getItem("fromDate");
    return stored ? JSON.parse(stored) : null;
  });
  const [to, setTo] = React.useState(() => {
    const stored = sessionStorage.getItem("toDate");
    return stored ? JSON.parse(stored) : null;
  });
  const [selectedLocation, setSelectedLocation] = React.useState(() => JSON.parse(sessionStorage.getItem("selectedLocation") || "[]"));
  const [selectedCalType, setSelectedCalType] = React.useState(() => JSON.parse(sessionStorage.getItem("selectedCalType") || "[]"));
  const [editAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
  const userType = localStorage.getItem("type");
  const userId = localStorage.getItem("id");

  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const getQuery = (count = false, removePagination = false) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (searchBy !== "" && searchKey !== "") {
      let colName = {
        "Client Name": "c.companyName",
        "SRF Number": "tm.srfNumber",
        "Instrument Name": "im.instrumentName",
      }[searchBy];

      whereConditions +=
        whereConditions.length > 0
          ? ` AND LOWER(${colName}) LIKE LOWER('%${searchKey}%')`
          : `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey}%')`;
    }
    if (to != null && from != null) {
      const { fromDate, toDate } = getFormattedDates(from, to);
      if (whereConditions === "") {
        whereConditions = " where ";
      } else {
        whereConditions += " and ";
      }

      whereConditions += ` tm.entryDate between '${fromDate}' and '${toDate}' `;
    }

    if (selectedLocation?.length > 0) {
      const locationIds = selectedLocation.map((item) => item.id).join(",");
      whereConditions +=
        whereConditions.length > 0
          ? ` AND isi.Location IN (${locationIds})`
          : `WHERE isi.Location IN (${locationIds})`;
    }

    if (selectedCalType?.length > 0) {
      const calibrationTypeIds = selectedCalType
        .map((item) => item.id).join(",");

      whereConditions +=
        whereConditions.length > 0
          ? ` AND isi.calibrationType IN (${calibrationTypeIds})`
          : `WHERE isi.calibrationType IN (${calibrationTypeIds})`;
    }

    if (!removePagination && rowsPerPage !== -1) {
      pagination_settings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(page)
        }`;
    }

    let data = {
      query: `SELECT tm.id, tm.srfNumber, tm.address, a.address AS addressName, tm.entryDate, tm.party, tm.InvoiceNo, tm.teamMember, tm.contactPerson, c.companyName, isi.id AS instrumentRowId, isi.instrumentId, im.instrumentName, isi.quantity, isi.orderType, isi.Location, isi.calibrationType, isi.OrderStatus
      FROM independentSrf tm LEFT JOIN clients c ON c.id = tm.clientId LEFT JOIN IndependentSrfInstruments isi ON isi.IndependentSrfId = tm.id LEFT JOIN addresses a ON a.id = tm.address LEFT JOIN instruments im ON im.id = isi.instrumentId ${whereConditions} ORDER BY tm.id DESC, isi.id ASC ${pagination_settings}`,
    };

    if (count) {
      data.query = `SELECT COUNT(*) AS no_of_rows FROM independentSrf tm LEFT JOIN clients c ON c.id = tm.clientId LEFT JOIN IndependentSrfInstruments isi ON isi.IndependentSrfId = tm.id LEFT JOIN addresses a ON a.id = tm.address LEFT JOIN instruments im ON im.id = isi.instrumentId ${whereConditions}`;
    }

    return data;
  };

  const getTotalRows = () => {
    let data = getQuery(true);
    axiosWithToken
      .post(BASE_URL + "dynamic", data)
      .then((res) => setTotalRows(res.data[0]?.no_of_rows))
      .catch((err) => console.error("Count fetch error:", err));
  };

  const fetchIndependentSrfList = () => {
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + "dynamic", data)
      .then((res) => setIndependentSrfList(res.data || []))
      .catch((err) => console.error("IndependentSrfList fetch error:", err));
  };

  function fetchAllDataForExcel() {
    const data = getQuery(false, true);
    axiosWithToken
      .post(BASE_URL + "dynamic", data)
      .then((res) => {
        const processed = res.data.map((item) => {
           let contactPersonName = "";
            try {
              contactPersonName = item.contactPerson ? (JSON.parse(item.contactPerson)?.contactPersonName || "") : "";
            } catch (e) {
              contactPersonName = "";
            }
          const obj = {
            "Date": item.entryDate ? moment(item.entryDate).format("YYYY-MM-DD") : "",
            "PRF": item.srfNumber || "",
            "Team Member": item.teamMember || "",
            "Party": item.party || "",
            "Company Name": item.companyName || "",
            "DOOR # WITH FULL ADDRESS": item.addressName || "",
            "CP Person": contactPersonName,
            instrumentName: item.instrumentName || "",
            quantity: item.quantity || "",
            orderType: orserTYpeArray.find(o => o.id == item.orderType)?.label || "",
            calibrationType: calTypeOption.find(o => o.id == item.calibrationType)?.label || "",
            location: locationOptions.find(o => o.id == item.Location)?.label || "",
            status: orderStatusOption.find(o => o.id == item.OrderStatus)?.label || "",
            invoiceNo: item.InvoiceNo || "",
          };
          return obj;
        });
        setFinalData(processed);
      })
      .catch((err) =>
        console.log("Failed to fetch data for Excel export", err),
      );
  }

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if (storedSearchBy) {
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    sessionStorage.setItem("selectedLocation", JSON.stringify(selectedLocation));
    sessionStorage.setItem("selectedCalType", JSON.stringify(selectedCalType));
    sessionStorage.setItem("fromDate", JSON.stringify(from));
    sessionStorage.setItem("toDate", JSON.stringify(to));
    setPage(0);
    setSearched(true);
    fetchIndependentSrfList();
    getTotalRows();
    fetchAllDataForExcel();
  };

  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("selectedLocation");
    sessionStorage.removeItem("selectedCalType");
    sessionStorage.removeItem("fromDate");
    sessionStorage.removeItem("toDate");
    setPage(0);
    setSearchBy("Client Name");
    setSearchKey("");
    setSelectedLocation([]);
    setSelectedCalType([]);
    setSearched(false);
    setFrom(null);
    setTo(null);
  };

  const handleDelete = (id) => {
    axiosWithToken
      .delete(BASE_URL + `independentSrf/${id}`)
      .then(() => {
        toast("SRF is deleted!");
        setTimeout(() => window.location.reload(false), 500);
      })
      .catch((err) => console.error(err));
  };

  const handleStatusUpdate = (id) => {
    axiosWithToken.patch(BASE_URL + `taskManagement/${id}`, { taskStatus: 2, })
      .then(() => {
        toast.success("Task marked as completed!");
        fetchIndependentSrfList();
        getTotalRows();
      })
      .catch((err) => console.error(err));
  };


  useEffect(() => {
    if (searched == false) {
      fetchIndependentSrfList();
      getTotalRows();
      fetchAllDataForExcel();
    }
    if (searched) {
      setPage(sessionStorage.getItem("ListPageCount") || 0);
    }
  }, [ searched]);

  useEffect(() => {
      fetchIndependentSrfList();
      getTotalRows();
      fetchAllDataForExcel();
  }, [rowsPerPage, page]);

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };


  const filterSection = () => (
    <Grid
      container
      spacing={2}
      alignItems="center"
      style={{ padding: "5px 0px" }}
    >
      <Grid item xs={12} sm={5} md={2} lg={1.5}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            slotProps={{ textField: { size: "small", fullWidth: true } }}
            className="Listinputcss"
            label="From"
            value={from ? new Date(from) : null}
            format="dd/MM/yyyy"
            onChange={(newValue) => { setFrom(newValue); setSearched(false); }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={5} md={2} lg={1.5}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            slotProps={{ textField: { size: "small", fullWidth: true } }}
            className="Listinputcss"
            label="To"
            value={to ? new Date(to) : null}
            format="dd/MM/yyyy"
            onChange={(newValue) => { setTo(newValue); setSearched(false); }}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} sm={5} md={2} lg={2}>
        <Autocomplete
          sx={{ m: 0, minWidth: 0, width: "100%" }}
          size="small"
          id="combo-box-demo"
          className="Listinputcss"
          value={searchBy}
          options={[
            { key: "clientName", label: "Client Name" },
            { key: "srfNumber", label: "SRF Number" },
            { key: "instrumentName", label: "Instrument Name" },
          ]}
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(_, newVal) => {
            setSearchBy(newVal);
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={5} md={2} lg={2}>
        <TextField
          style={{ width: "100%" }}
          label={"Enter " + searchBy}
          size="small"
          className="Listinputcss"
          variant="outlined"
          inputProps={{ autoComplete: "off" }}
          value={searchKey}
          onChange={(e) => {
            setSearchKey(e.target.value);
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={5} md={2} lg={2}>
        <Autocomplete
          size="small"
          multiple
          options={locationOptions}
          className="Listinputcss"
          getOptionLabel={(option) => option.label || ""}
          value={selectedLocation}
          onChange={(_, newValue) => {
            setSelectedLocation(newValue);
            setSearched(false);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Location" />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={5} md={2} lg={2}>
        <Autocomplete
          size="small"
          multiple
          options={calTypeOption}
          className="Listinputcss"
          getOptionLabel={(option) => option.label || ""}
          value={selectedCalType}
          onChange={(_, newValue) => {
            setSelectedCalType(newValue);
            setSearched(false);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Calibration Type" />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2} lg={1} textAlign="left">
        <Button
          variant="contained"
          size="small"
          color={searched ? "error" : "primary"}
          onClick={() => {
            searched ? clearSearch() : search();
            handleFilterClose();
          }}
        >
          {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </Grid>
      {finalData.length > 0 && (
       <Grid item xs={12} sm={6} md={2} lg={2} textAlign="left">
        <ExcelDownload finalData={finalData} notNeededColumn={[]} />
       </Grid>
      )}
    </Grid>
  );

  const filterModal = () => {
    return (
    <Modal open={filterModalOpen}>
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "calc(100% - 30%)",
          backgroundColor: "white",
          boxShadow: 24,
          padding: "10px",
        }}
      >
        <Button
          variant="contained"
          size="small"
          color="error"
          style={{ float: "right" }}
          onClick={handleFilterClose}
        >
          X
        </Button>
        {filterSection()}
      </Box>
    </Modal>
   );
  };

  return (
    <ListWrap>
      {filterModal()}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Toolbar style={{ padding: "0px" }}>
          {(userType == 1 || userType == 4) && (
            <Button
              variant="contained"
              size="small"
              component={Link}
              to="/editindependentSrf/0"
            >
              <b>ADD SRF</b>
            </Button>
          )}
        </Toolbar>
        <Button
          style={{ display: isMobile ? "block" : "none" }}
          onClick={handleFilterOpen}
        >
          <FilterAltIcon />
        </Button>
      </Box>

      {!isMobile && filterSection()}

      <TableContainer sx={{ maxHeight: isMobile ? "75vh" : "65vh" }}>
        <Table stickyHeader aria-label="sticky table" size="small" style={{borderCollapse:"collapse"}}>
          <TableHead>
            <TableRow>
              <TableCell align="left" style={{ minWidth: 40 }}><b>Sr.No.</b></TableCell>
              <TableCell align="left" style={{ minWidth: 120 }}><b>Client</b></TableCell>
              <TableCell align="left" style={{ minWidth: 120 }}><b>Address</b></TableCell>
              <TableCell align="left" style={{ minWidth: 100 }}><b>SRF No.</b></TableCell>
              <TableCell align="left" style={{ minWidth: 110 }}><b>Date</b></TableCell>
              <TableCell align="left" style={{ minWidth: 100 }}><b>Party</b></TableCell>
              <TableCell align="left" style={{ minWidth: 100 }}><b>Invoice No.</b></TableCell>
              <TableCell align="left" style={{ minWidth: 130 }}><b>Instrument Name</b></TableCell>
              <TableCell align="left" style={{ minWidth: 90 }}><b>Quantity</b></TableCell>
              <TableCell align="left" style={{ minWidth: 100 }}><b>Order Type</b></TableCell>
              <TableCell align="left" style={{ minWidth: 100 }}><b>Location</b></TableCell>
              <TableCell align="left" style={{ minWidth: 100 }}><b>Calibration Type</b></TableCell>
              <TableCell align="left" style={{ minWidth: 100 }}><b>Status</b></TableCell>
              <TableCell align="left" style={{ minWidth: 80 }}><b>Actions</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {IndependentSrfList?.length > 0 ? (
              IndependentSrfList.map((row, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={`${row.id}-${row.instrumentRowId}`}>
                  <TableCell align="left">{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell align="left">{row.companyName || "-"}</TableCell>
                  <TableCell align="left" sx={{ maxWidth: 180, width: 180, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{row.addressName  || "-"}</TableCell>
                  <TableCell align="left">{row.srfNumber || "-"}</TableCell>
                  <TableCell align="left">
                    {row.entryDate ? moment(row.entryDate).format("YYYY-MM-DD") : "-"}
                  </TableCell>
                  <TableCell align="left">{row.party || "-"}</TableCell>
                  <TableCell align="left">{row.InvoiceNo || "-"}</TableCell>
                  <TableCell align="left">{row.instrumentName || "-"}</TableCell>
                  <TableCell align="left">{row.quantity || 0}</TableCell>
                  <TableCell align="left">{orserTYpeArray.find((opt) => opt.id == row.orderType)?.label || ""}</TableCell>
                  <TableCell align="left">{locationOptions.find((opt) => opt.id == row.Location)?.label || ""}</TableCell>
                  <TableCell align="left">{calTypeOption.find((opt) => opt.id == row.calibrationType)?.label || ""}</TableCell>
                  <TableCell align="left">{orderStatusOption.find((opt) => opt.id == row.OrderStatus)?.label || ""}</TableCell>
                  <TableCell>
                    <ButtonGroup size="small" aria-label="small button group">
                      {(userType == 1 || userType == 4) && (
                        <>
                          <Tooltip title="Edit SRF" placement="top-start">
                            <Button component={Link} to={`/editindependentSrf/${row.id}`}>
                              <PreviewIcon />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Delete SRF" placement="top-start">
                            <Button
                              disabled={!(editAccess?.includes(2) || editAccess?.includes(0))}
                              onClick={() => {
                                if (window.confirm("Are you sure you want to delete this?"))
                                  handleDelete(row.id);
                              }}
                            >
                              <DeleteIcon
                                style={{
                                  color: !(editAccess?.includes(2) || editAccess?.includes(0))
                                    ? "lightgray"
                                    : "#dc3545",
                                }}
                              />
                            </Button>
                          </Tooltip>
                        </>
                      )}
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={13} align="center">
                  <h6><b>Data Not Found</b></h6>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={paginationrowsPerPageOptions}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
    </ListWrap>
  );
};

export default IndependentSrfList;